import React from 'react'
import Link from 'next/link'

// TODO: manage onchain addresses,
// TODO:

// Manage wallets, store last wallet name by address, store last exported date by wallet

// Store imports in amplify datastore? -> Manage in multi subaccounts

// Always determine imported row by id, best from onchain, otherwise

// Add intermediate format, which provides more insights, and build single exporter component from there

// Manage Auth

// BTCPayServer Donation button (free 3rd party)

// Nice-To-Have

interface Page {
	label: string
	href: string
}

const rootSettingsPath = '/settings'

export const subPages: Page[] = [{ label: 'Accounts', href: `${rootSettingsPath}/accounts` }]

const SettingsPage = () => {
	return (
		<div>
			<h1>Settings</h1>
			{subPages.map((page) => {
				const { href, label } = page
				return (
					<Link href={href} key={href}>
						<a>{label}</a>
					</Link>
				)
			})}
		</div>
	)
}

export default SettingsPage
